import React, { useState } from 'react';

import Navigation from '../Navigation/Navigation';
import styles from './HeaderTop.module.css';
import { NavLink } from 'react-router-dom';
import Logo from '../../images/logo.png';
import BurgerMenu from '../customComponents/BurgerMenu/BurgerMenu';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsMuted } from '../../redux/settings/selectors';
import { setMuted } from '../../redux/settings/slice';
import { FaBell } from 'react-icons/fa';
import { BsFillBellSlashFill } from 'react-icons/bs';
import { selectUser } from '../../redux/auth/selectors';

const screenWidth = window.screen.width;
const isMobile = screenWidth < 768;

export default function Header() {
  const [burgerState, setBurgerState] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isPaidUser = user?.typeAccount === 'paidUser';
  const isMuted = useSelector(selectIsMuted);
  const handleChangeMuted = () => {
    dispatch(setMuted(!isMuted));
  };

  if (isMobile) {
    return (
      <header className={styles.mobileContainer}>
        <div className={styles.burgerContainer}>
          <GiHamburgerMenu
            style={{ color: 'white', fontSize: '30px', cursor: 'pointer' }}
            onClick={() => {
              setBurgerState(true);
            }}
          />
        </div>
        <div className={styles.logoContainer}>
          <NavLink to="/">
            <img
              loading="lazy"
              decoding="async"
              src={Logo}
              alt="DOL- Online Dating"
              width={180}
              height={60}
            />
          </NavLink>
        </div>
        {isPaidUser && (
          <div className={styles.notificationWrapper}>
            {!isMuted && (
              <FaBell
                color="white"
                className={styles.notification}
                onClick={handleChangeMuted}
              />
            )}

            {isMuted && (
              <BsFillBellSlashFill
                color="white"
                className={styles.notification}
                onClick={handleChangeMuted}
              />
            )}
          </div>
        )}

        <BurgerMenu
          isOpen={burgerState}
          close={() => {
            setBurgerState(false);
          }}
        />
      </header>
    );
  }
  return (
    <header className={styles.headerContainer}>
      <NavLink to="/">
        <img
          loading="lazy"
          decoding="async"
          src={Logo}
          alt="DOL- Online Dating"
          width={180}
          height={60}
        />
      </NavLink>

      <div className={styles.navMenuContainer}>
        <Navigation></Navigation>
      </div>
    </header>
  );
}
